import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
import { processSteps } from '../data/site';
export function Process() {
  return <>
      <PageHero eyebrow="How we work" title="A clear path to a safer property." subtitle="No surprise pricing. No mystery hardware. Every Watchdog project follows the same simple four-step process." data-id="element-406">
        <CTAButton to="/assessment" data-id="element-407">Start with a free walkthrough</CTAButton>
      </PageHero>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-408">
        <div className="grid gap-6 md:grid-cols-2" data-id="element-409">
          {processSteps.map((item, i) => <motion.div key={item.step} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm" data-id="element-410">
              <div className="text-6xl font-black text-sky-200" data-id="element-411">
                {item.step}
              </div>
              <h3 className="mt-6 text-2xl font-black" data-id="element-412">{item.title}</h3>
              <p className="mt-3 leading-7 text-slate-600" data-id="element-413">{item.text}</p>
            </motion.div>)}
        </div>
      </section>

      <section className="bg-slate-950 py-20 text-white" data-id="element-414">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-415">
          <SectionLabel dark data-id="element-416">What to expect</SectionLabel>
          <h2 className="text-3xl font-black sm:text-4xl" data-id="element-417">
            Most projects move from walkthrough to install in under two weeks.
          </h2>
          <div className="mt-10 grid gap-4 sm:grid-cols-3" data-id="element-418">
            {[['Day 1', 'On-site walkthrough'], ['Day 2–4', 'Custom plan and quote'], ['Day 5–10', 'Installation and training']].map(([day, label]) => <div key={day} className="rounded-3xl border border-white/10 bg-white/[0.06] p-6" data-id="element-419">
                <p className="text-sm font-black text-sky-300" data-id="element-420">{day}</p>
                <p className="mt-2 font-bold" data-id="element-421">{label}</p>
              </div>)}
          </div>
          <div className="mt-10" data-id="element-422">
            <CTAButton to="/assessment" data-id="element-423">Schedule my walkthrough</CTAButton>
          </div>
        </div>
      </section>
    </>;
}